module.exports = __webpack_public_path__ + "img/hexagon-triangle.1fdd19e7.png";